import React from 'react';
export function SiteFooter() {
  return <footer className="bg-ink px-4 pb-28 pt-12 sm:px-6" data-id="element-268" data-mp="1dqrovx7i9m8c">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-269" data-mp="3r7zl1eahka7k">
        <p className="text-base font-black uppercase tracking-wide text-white sm:text-lg" data-id="element-270" data-mp="3ralvblorh3th">
          🦷 Aligner Treatment Blueprint™
        </p>
        <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.18em] text-sky" data-id="element-271" data-mp="3hheri59o5vvi">
          Plan. Organize. Control. Refine. Finish.
        </p>
        <p className="mt-4 font-script text-xl text-white/80" data-id="element-272" data-mp="3dei48196pbl8">
          Created by Dr. Karito
        </p>

        <p className="mt-7 text-[11.5px] leading-relaxed text-white/50" data-id="element-273" data-mp="33iou0oixtu6m">
          These materials are educational and organizational resources. They do
          not replace professional education, diagnosis, clinical judgment,
          manufacturer instructions, or applicable laws and regulations.
        </p>

        <p className="mt-5 text-[11.5px] text-white/40" data-id="element-274" data-mp="wsh02fset1i0">
          © 2026 · Dr. Karito – ALIGNER TREATMENT BLUEPRINT™ All Rights
          Reserved.
        </p>
      </div>
    </footer>;
}